import axios from 'axios';
import getApiBaseUrl from '../GetServer';

export interface EditOrCreateChatBot {
  IDChatbot: number;
  IDCliente: number;
  Key: string;
  Nombre: string;
  Color: string;
  Icono: string;
  IconoName: string;
  Status: number;
  IDAgente: number;
  mensajeChat: string;
  AllowedDomains: string;
  redFace: string;
  redInstagran: string;
  redGmail: string;
}

interface Response {
  status: number;
  message: string;
}

export const SendChatBot = async (data: EditOrCreateChatBot): Promise<Response> => {
  try {
    const baseUrl = getApiBaseUrl();
    const endpoint = `${baseUrl}dash/edit-or-create-chatbot`;

    const token = localStorage.getItem("token");
    if (!token) {
      return { status: 401, message: "Token no disponible" };
    }

    const response = await axios.post<Response>(endpoint, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error: any) {
    if (axios.isAxiosError(error) && error.response) {
      const res = error.response.data;
      return {
        status: res.status || 500,
        message: res.message || "Error inesperado en el servidor",
      };
    }

    return {
      status: 500,
      message: "Error al conectar con el servidor",
    };
  }
};
